module.exports = __webpack_public_path__ + "img/big_bar.d1a6b0bf.png";